import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

import stylesJS from "./assets/styles.js"
import styleJSON from "./assets/style.json"
import generalJS from "./functions/general.js"

import textItem from './items/textItem.vue'
import deleteItemIcon from './items/deleteItemIcon.vue'
import fileUpload from './containers/fileUpload.vue'
import svgItem from './items/svgItem.vue'
import chartItem from './items/chartItem.vue'
import timeLine from './items/timeLine.vue'
import inputArea from './items/inputArea.vue'
import inputLine from './items/inputLine.vue'
import itemScroll from './containers/itemScroll.vue'
import itemModal from './containers/itemModal.vue'
import dbGroup from './containers/dbGroup.vue'
import toolTip from './containers/toolTip.vue'


import inputBox from './containers/inputBox.vue'
import buttonGroup from './components/buttonGroup.vue'
import listGroup from './components/listGroup.vue'
import listGroup2 from './components/listGroup2.vue'
import switchGroup from './components/switchGroup.vue'
import expandGroup from './components/expandGroup.vue'
import inputDate from './components/inputDate.vue'
import inputNewDate from './components/inputNewDate.vue'
import dropdownBox from './containers/dropdownBox.vue'
import tlCsLine from './items/tlCsLine.vue'
import tlColumns from './items/tlColumns.vue'
import tlLabels from './items/tlLabels.vue'
import inputComboBox from './components/inputComboBox.vue'
import inputComboBox2 from './components/inputComboBox2.vue'
import inputAreaAuto2 from './items/inputAreaAuto2.vue'
import inputLineNew2 from './items/inputLineNew2.vue'
import inputNumber from './items/inputNumber.vue'

import esButtonIcon from '@//components/esButtonIcon.vue'
import esButtonNavigation from '@//components/esButtonNavigation.vue'
import esButton from '@/components/esButton.vue'
import esInputCheckbox from '@/components/esInputCheckbox.vue'
import esTagList from '@/components/esTagList.vue'
import esSelect from '@/components/esSelect.vue'
import esSelectInput from '@/components/esSelectInput.vue'
import esDoctorItem from '@/components/share/esDoctorItem.vue'
import esInputDateTime from '@/components/esInputDateTime.vue'

import esModalHeader from '@/components/modals/esModalHeader.vue'
import esModalFooter from '@/components/modals/esModalFooter.vue'

import i18n from './i18n'
import VCalendar from 'v-calendar'
import 'v-calendar/dist/style.css'

import PrimeVue from 'primevue/config'
import { definePreset } from '@primeuix/themes'
import Aura from '@primevue/themes/aura'
import fr from './config/primevue/fr'
import { ToastService, Tooltip } from 'primevue'
import { vOneClick } from './directive/one-click'

// Create Pinia & App
const pinia = createPinia()
const myApp = createApp(App)

//Directive
myApp.directive('one-click', vOneClick)

// Global variables & JS
myApp.config.globalProperties.$style = styleJSON
myApp.config.globalProperties.$styles = stylesJS
myApp.config.globalProperties.$gen = generalJS

//i18n
myApp.use(i18n);

//Router
myApp.use(router)

// Use plugin defaults (optional)
myApp.use(VCalendar, {})


//VueQuery
// myApp.use(VueQueryPlugin)

// Items
myApp.component('textItem', textItem)
myApp.component('deleteItemIcon', deleteItemIcon)
myApp.component('fileUpload', fileUpload)
myApp.component('svgItem', svgItem)
myApp.component('chartItem', chartItem)
myApp.component('timeLine', timeLine)
myApp.component('inputArea', inputArea)
myApp.component('inputLine', inputLine)
myApp.component('itemScroll', itemScroll)
myApp.component('itemModal', itemModal)
myApp.component('dbGroup', dbGroup)
myApp.component('toolTip', toolTip)

myApp.component('inputBox', inputBox)
myApp.component('buttonGroup', buttonGroup)
myApp.component('listGroup', listGroup)
myApp.component('listGroup2', listGroup2)
myApp.component('switchGroup', switchGroup)
myApp.component('expandGroup', expandGroup)
myApp.component('inputDate', inputDate)
myApp.component('inputNewDate', inputNewDate)
myApp.component('dropdownBox', dropdownBox)
myApp.component('tlCsLine', tlCsLine)
myApp.component('tlColumns', tlColumns)
myApp.component('tlLabels', tlLabels)
myApp.component('inputComboBox', inputComboBox)
myApp.component('inputComboBox2', inputComboBox2)
myApp.component('inputAreaAuto2', inputAreaAuto2)
myApp.component('inputLineNew2', inputLineNew2)
myApp.component('inputNumber', inputNumber)
myApp.component('esButtonIcon', esButtonIcon);
myApp.component('esButtonNavigation', esButtonNavigation);
myApp.component('esButton', esButton);
myApp.component('esInputCheckbox', esInputCheckbox);
myApp.component('esTagList', esTagList);
myApp.component('esSelect', esSelect);
myApp.component('esSelectInput', esSelectInput);
myApp.component('esDoctorItem', esDoctorItem);
myApp.component('esInputDateTime', esInputDateTime);

myApp.component('esModalHeader', esModalHeader);
myApp.component('esModalFooter', esModalFooter);
// Standard
myApp.use(pinia)
myApp.use(ToastService);
myApp.directive('tooltip', Tooltip);
myApp.mount('#app')

// Primevue
const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#F5F5FF',
      100: '#EOEOFF',
      200: '#B8B8FF',
      300: '#8A8AFF',
      400: '#6161FF',
      500: '#4747FF',
      600: '#1414FF',
      700: '#0000FO',
      800: '#0000CC',
      900: '#000094'
    }
  }
});

myApp.use(PrimeVue, {
  locale: fr,
  theme: {
    preset: MyPreset,
    options: {
      darkModeSelector: 'none',
      darkMode: false,
      cssLayer: {
        name: 'primevue',
        order: 'theme, base, primevue'
      }
    }
  },
  zIndex: {
    modal: 11004,
    overlay: 11004      //select, popover
  }
});